module.exports = __webpack_public_path__ + "img/TECNOLOGIA-ERTIGA-2.450119aa.jpg";